function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.255 12.475h.867l5.478 5.49-1.636 1.635-5.489-5.478v-.867l-.296-.308a7.104 7.104 0 01-4.644 1.724 7.135 7.135 0 117.136-7.136 7.104 7.104 0 01-1.724 4.644l.308.296zm-10.66-4.94a4.933 4.933 0 004.94 4.94 4.933 4.933 0 004.94-4.94 4.933 4.933 0 00-4.94-4.94 4.933 4.933 0 00-4.94 4.94z",
  fill: "#555"
});

function SvgSearchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearchinline;